/*
 * This library provides common SOAP service Class for more convenient way of creating a specialized service wrapper
 * Most services can expose service contracts through WSDL meta description which can be accessed by appending "?wsdl" to service url
 * Some definitians can be found here "https://services.bamnetworks.com/ws/services/IdentityPointService?xsd=xsd0"
 */

define('soap/common',['require','exports','module','bam.cookies/cookies','./soap'],function( require, exports, module ) {
    "use strict";

	//Checks response Body to see if error status is thrown

    var cookies = require('bam.cookies/cookies');
    var soap = require('./soap');

    function isErrorThrown(responseBody) {
        return (responseBody.find("status.code[Text != 1]").length > 0);
    }
    //Returns a normalized status object


    function getStatus(responseBody) {
        var responseStatus = responseBody.status[0],
            status = {
                "code": +(responseStatus.find("code.Text").toString()),
                "message": responseStatus.find("message.Text").toString()
            };

        if (responseStatus.detail) {
            status.detailList = [];
            for (var i = 0, l = responseStatus.detail, r, detail; l > i; i++) {
                r = responseStatus.detail[i];
                detail = {
                    "type": r.attr('type') || '',
                    "field": r.attr('field') || '',
                    "message": r.attr('message') || '',
                    "messageKey": r.attr('messageKey') || '',
                    "rule": r.attr('rule') || ''
                };
                status.detailList[i] = detail;
            }
        }

        return status;
    }
    //Extracts fault codes from a faulty service response

    function getFaultCode(responseBody) {
        var faultCode = responseBody.find("faultcode.Text").toString(),
            faultMessage = responseBody.find("faultstring.Text").toString(),

            status = {
                "code": faultCode,
                "message": faultMessage
            };
        return status;
    }

    var TRUE = !0;

        //MLB Proxy
        exports.proxyURI = "/pubajaxws/services/";

        exports.ns = "http://services.bamnetworks.com/registration/types/1.6";

        //This function attempts to extract default user identity from cookies
        exports.getUserIdentity = function() {
            return {
                "@type": "fingerprint",
                id: cookies.get("ipid"),
                fingerprint: cookies.get("fprt")
            };
        };

        //Ensures that input parameter contains indentity and retrieves user identity from cookies if it's missing
        exports.ensureIdentity = function(params) {
            params = params || {};
            if (!params.identification) {
                params.identification = this.getUserIdentity();
            } else {
                //Set ipid/fprt defaults if missing
                params.identification = $.extend(this.getUserIdentity(), params.identification);
            }
            return params;
        };

        /**
        * Checks parameter for presense and throws error if it's missing
        * @params <Object> - object that we check against
        * @name <String>|<Array<String>> - one or many property names that we check for presense in params
        */
        exports.checkRequired = function(params, name) {
            if (typeof params !== "undefined" && typeof name !== "undefined") {
                if ($.isArray(name)) {
                    for (var i = name.length - 1; i >= 0; i--) {
                        if (!(name[i] in params)) {
                            throw new Error("Required parameter [" + name[i] + "] is missing");
                        }
                    }
                } else {
                    if (!(name in params)) {
                        throw new Error("Required parameter [" + name + "] is missing");
                    }
                }
            } else {
                throw new Error("Required parameters are missing");
            }
        };
        /*
         * Service wrapper and SOAP factory
         * @name <String> - Service name as it's defined in WSDL definition
         * @actionURI <String> - General actions URI w/o any action prefix
         * Action URI inside [ ]: [http://services.bamnetworks.com/registration/subscription/]find
         */
        exports.SOAPService = function(name, actionURI, ns) {
            this.name = name;
            this.proxy = exports.proxyURI + this.name;
            this.actionURI = actionURI;
            this.ns = ns || exports.ns;
            this.client = new soap.SOAPClient({
                proxy: this.proxy
            });
        };


    /*
     * Performs SOAP action call
     * @action <String> - name of the action to perform
     * @requestTag <String> - name of the request tag specified in WSDL as complexType (i.e. [description]_request)
     * @responseTag <String> - name of the tag containing response data inside Body
     * @soapBody <Object> - SOAP Body payload. Actual data.
     * @successFilter <Function> - Optional data filter to allow done method to return modified value
     * "Must be replaced by pipe() when we start using jQuery 1.6"
     */
    exports.SOAPService.prototype = {
        createRequest: function(action, payload) {
            return new soap.SOAPRequest({
                action: this.actionURI + action
            }, payload);
        },
        callAction: function(action, requestTag, responseTag, soapBody, successFilter) {
            switch (TRUE) {
            case (!action):
                throw new Error("Required action argument is missing");
            case (!requestTag):
                throw new Error("Required requestTag argument is missing");
            case (!responseTag):
                throw new Error("Required responseTag argument is missing");
            case (!soapBody):
                throw new Error("Required soapBody argument is missing");
            }
            //Construct a payload
            var payload = {};
            payload[requestTag] = soapBody;
            payload[requestTag]["@xmlns"] = this.ns;

            var that = this,
                def = $.Deferred(),
                request = new soap.SOAPRequest({
                    action: this.actionURI + action
                }, payload),
                status, error = {
                    operation: that.name + "." + action
                };

            //Send request to the server
            this.client.sendRequest(request).then(
            //Successful SOAP response

            function(response) {
                var bodyTag = response.Body.find(responseTag);
                bodyTag = bodyTag.length && bodyTag[0];

                if (bodyTag) {
                    if (!isErrorThrown(bodyTag)) {
                        if ($.isFunction(successFilter)) {
                            def.resolve(successFilter.apply(this, [bodyTag]));
                        } else {
                            def.resolve(bodyTag);
                        }
                    } else {
                        //Service did return errors
                        status = getStatus(bodyTag);
                        $.extend(error, status);
                        def.reject(error);
                    }
                }
                //Service did not return Body - something is seriously wrong
                else {
                    $.extend(error, {
                        code: -100000,
                        message: "Unknown service error"
                    });
                    def.reject(error);
                }

            },
            //AJAX call failed

            function(response) {
                var bodyTag = response.Body.find("Fault");
                bodyTag = bodyTag.length && bodyTag[0];
                if (bodyTag) {
                    status = getFaultCode(bodyTag);
                    $.extend(error, status);
                    def.reject(error);
                } else {
                    $.extend(error, {
                        code: -100000,
                        message: "AJAX request failed"
                    });
                    def.rejectWith(this, [error]);
                }
            });

            return def.promise();
        }
    };

});

